import {Command} from "../command";
import {CommandType} from "../commandType";
import {EstimateRowType} from "../state/estimateRowType";
import * as $ from "jquery";
import {EstimateTextRowPopupParams} from "../../components/estimate-text-row-popup/estimate-text-row-popup";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";
import {EstimateCostRowPopupParams} from "../../components/estimate-cost-row-popup/estimate-cost-row-popup";
import {EstimateSubtotalRowPopupParams} from "../../components/estimate-subtotal-row-popup/estimate-subtotal-row-popup";

export class EditEstimateRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.EditEstimateRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (estimate.selectedRow().length == 0 && !estimate.baseRow())
            return false;

        let row = estimate.selectedRow().length != 0 ? estimate.selectedRow()[0]: estimate.baseRow();

        if (!row)
            return false;

        return row.type == EstimateRowType.text || row.type == EstimateRowType.cost || row.type == EstimateRowType.subtotal;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();

        if (!estimate)
            return $.Deferred().reject().promise();

        if (estimate.selectedRow().length == 0 && !estimate.baseRow())
            return $.Deferred().reject().promise();

        let row = estimate.selectedRow().length != 0 ? estimate.selectedRow()[0]: estimate.baseRow();

        if (!row)
            return $.Deferred().reject().promise();
        
        switch (row.type) {
            case EstimateRowType.text:
                return this.app.popupsManager.show<EstimateTextRowPopupParams>(PopupType.estimateTextRow, false, <EstimateTextRowPopupParams> {
                    popupMode: PopupMode.Edit,
                });
            case EstimateRowType.cost:
                return this.app.popupsManager.show<EstimateCostRowPopupParams>(PopupType.estimateCostRow, false, <EstimateCostRowPopupParams> {
                    popupMode: PopupMode.Edit,
                });
            case EstimateRowType.subtotal:
                return this.app.popupsManager.show<EstimateSubtotalRowPopupParams>(PopupType.estimateSubtotalRow, false, <EstimateSubtotalRowPopupParams> {
                    popupMode: PopupMode.Edit,
                });
        }
        
        return $.Deferred().reject().promise();
    }

    name = "Edit Estimate Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/editEstimateRowCommand.ts